module.exports = __webpack_public_path__ + "img/ABC.bb4e8f46.png";